// extracted by mini-css-extract-plugin
export default {"box":"mastersCategoryPage_box__JMPg2"};